import './app.scss';

import MobileDetect from 'mobile-detect';

import { initSliders } from './js/sliders';
import { PaginationController } from './js/pagination';
import { registerAnalytics } from './js/analytics';

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = md.mobile() !== null;

initSliders(isMobile);
registerAnalytics();

if (!isMobile) {
    const paginationController = new PaginationController();

    paginationController.init();
}
